<ng-container *transloco="let t; read: 'conversation-spam-detection-config-editor'">
  <div *ngIf="!loading">
    <ng-template #objEditor>
      <legend>{{ t('title') }}</legend>

      <p-messages severity="info">
        <ng-template pTemplate>
          {{ t('infoBanner') }}
        </ng-template>
      </p-messages>

      <form [formGroup]="form">
        <!-- Enable Spam Filtering -->
        <div class="field">
          <p-checkbox
            id="spamDetectionEnabled"
            [ariaLabel]="t('enabledLabel')"
            [binary]="true"
            [formControl]="enabled"
            [label]="t('enabledLabel')"
          >
          </p-checkbox>
          <p *ngIf="waitingRoomEnabled; else enabledHelpText" class="mt-1 mb-0 text-color-secondary">
            {{ t('waitingRoomConflict') }}
          </p>
          <ng-template #enabledHelpText>
            <p class="mt-1 mb-0">{{ t('enabledHelp') }}</p>
          </ng-template>
        </div>

        <!-- Spam Detection Instructions -->
        <div class="field">
          <label class="block font-semibold" for="spamDetectionInstructions">{{ t('instructionsLabel') }}</label>
          <p class="block mb-2">{{ t('instructionsHelp') }}</p>
          <textarea
            class="w-full"
            formControlName="instructions"
            id="spamDetectionInstructions"
            pInputTextarea
            rows="8"
            [placeholder]="t('instructionsPlaceholder')"
          ></textarea>
          <app-form-field-help [control]="instructions">
            <ng-container form-field-help-errors>
              <ng-container *ngIf="instructions.errors?.required">{{ t('instructionsRequired') }}</ng-container>
              <ng-container *ngIf="instructions.errors?.minlength">{{ t('instructionsMinLength') }}</ng-container>
            </ng-container>
          </app-form-field-help>
        </div>

        <!-- Automatic Spam Response -->
        <div class="field">
          <label class="block font-semibold" for="spamDetectedMessage">{{ t('spamDetectedMessageLabel') }}</label>
          <p class="block mb-2">{{ t('spamDetectedMessageHelp') }}</p>
          <textarea
            class="w-full"
            formControlName="spamDetectedMessage"
            id="spamDetectedMessage"
            pInputTextarea
            rows="4"
            [placeholder]="t('spamDetectedMessagePlaceholder')"
          ></textarea>
          <app-form-field-help [control]="spamDetectedMessage">
            <ng-container form-field-help-errors>
              <ng-container *ngIf="spamDetectedMessage.errors?.required">{{
                t('spamDetectedMessageRequired')
              }}</ng-container>
            </ng-container>
            <ng-container form-field-help-hint>{{ t('spamDetectedMessageDisclaimer') }}</ng-container>
          </app-form-field-help>
        </div>

        <!-- Legitimate Message Detected -->
        <div class="field">
          <label class="block font-semibold" for="spamFilteringPassedMessage">{{
            t('spamFilteringPassedMessageLabel')
          }}</label>
          <p class="block mb-2">{{ t('spamFilteringPassedMessageHelp') }}</p>
          <textarea
            class="w-full"
            formControlName="spamFilteringPassedMessage"
            id="spamFilteringPassedMessage"
            pInputTextarea
            rows="4"
            [placeholder]="t('spamFilteringPassedMessagePlaceholder')"
          ></textarea>
          <app-form-field-help [control]="spamFilteringPassedMessage">
            <ng-container form-field-help-errors>
              <ng-container *ngIf="spamFilteringPassedMessage.errors?.required">{{
                t('spamFilteringPassedMessageRequired')
              }}</ng-container>
            </ng-container>
          </app-form-field-help>
        </div>
      </form>
    </ng-template>

    <app-settings
      auditEntryLabel="Conversation Config"
      [auditEntry]="auditEntry"
      [doUpload]="upload"
      [editorTemplate]="objEditor"
      [isValid]="isValid"
      [refreshData]="refreshData"
      [resetForm]="updateUI"
    >
    </app-settings>
  </div>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</ng-container>
